const checkSizingChart = () => {
  const originalButton = document.querySelector('product-addons[data-text-header="Size Guide"]')
  var teeOptionTitle = document.querySelector(".tee-option--size .tee-option__title");
  if (originalButton && teeOptionTitle) {
    var existingClone = teeOptionTitle.querySelector('.product-addons__ask-question');
    if (!existingClone) {
      const clonedDiv = document.createElement('div');
      clonedDiv.className = originalButton.className;
      clonedDiv.style = originalButton.getAttribute('style');
      clonedDiv.innerHTML = originalButton.innerHTML; 
      clonedDiv.addEventListener('click', () => {
        originalButton.click();
      });
      teeOptionTitle.appendChild(clonedDiv);
    }
  }
  
};

document.addEventListener("teeinblue-event-variant-changed", checkSizingChart);

document.addEventListener("teeinblue-event-component-injected", () => {
  const checkElementRendered = setInterval(() => {
    if (document.querySelector('product-addons[data-text-header="Size Guide"]')) {
      checkSizingChart();
      clearInterval(checkElementRendered);
    }
  }, 1000);

  document.querySelectorAll(".tee-available-products .tee-radio").forEach((radio) => {
    radio.addEventListener("click", () => {
      setTimeout(() => {
        checkSizingChart();
      }, 200);
    });
  });
})


document.addEventListener('teeinblue-event-after-cart-added',async  function() {
  const drawer = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  fetch("/cart.json")
  .then((res) => res.json())
  .then((cart) => {
    if (cart.item_count != undefined) {
      document.querySelectorAll(".cart-count").forEach((el) => {
        if (el.classList.contains("cart-count-drawer")) {
          el.innerHTML = `(${cart.item_count})`;
        } else {
          el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
        }
      });
      if (document.querySelector("header-total-price")) {
        document.querySelector("header-total-price").updateTotal(cart);
      }
      const cart_free_ship = document.querySelector("free-ship-progress-bar");
      if (cart_free_ship) {
        cart_free_ship.init(cart.items_subtotal_price);
      }
    }
  })
  .catch((error) => {
    throw error;
  });
  
  if (drawer) {
    fetch(window.location.pathname + "?sections=minicart-form")
    .then(res => res.json())
    .then(res => {
      drawer.getSectionsToRender().forEach((section) => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        const html = new DOMParser().parseFromString(res[section.id],'text/html');
        if (elementToReplace) {
          elementToReplace.innerHTML = html.querySelector('#minicart-form').innerHTML;
        }
      });
      drawer.cartAction();
      if (drawer && drawer.classList.contains('is-empty')) {
        drawer.classList.remove('is-empty');
      }
      drawer.open();
    });
  }
})